import styled from 'styled-components';

import { fadeIn } from 'utils/style/animations';

import { QuestCard } from './loyalty-quest-card/loyalty-quest-card';

export const QuestsTitle = styled.h2`
  font-size: 1.375rem;
  padding-inline-start: 1.625rem;
  color: ${Styles.color.primary};
`;

export const StyledQuestCard = styled(QuestCard)<{ $fadeDelayMultiplier: number }>`
  transition: 0.25s;
  opacity: 0;
  animation: ${fadeIn} 0.5s ${({ $fadeDelayMultiplier = 0 }) => 0.15 * $fadeDelayMultiplier}s
    forwards;
`;
